<div class="d-flex justify-content-center mt-plus">
  @if (banners().length > 1) {
    <ngx-carousel
      [mode]="'CARD'"
      [visibleItemCount]="1"
      [index]="0"
      [centerMode]="false"
      [showNavigation]="true"
      [showButtons]="false"
      [isFixedGap]="true"
      [fixedGap]="10"
      [changeStepThresholdPercentage]="20"
      [swipeThreshold]="100"
      [disableNavigationDots]="true"
      [disableScaling]="true"
      [enableAutoPlay]="true"
      [autoPlayDurationMillis]="5000"
    >
      @for (banner of banners(); track $index) {
        <div
          ngxCarouselSlide
          class="d-flex justify-content-center align-items-center w-100"
        >
          <img
            (click)="openInvestments(banner)"
            [src]="banner.iconPath"
            width="100%"
            [id]="'BANNER_' + banner?.title"
            alt="banner"
          />
        </div>
      }
      >
    </ngx-carousel>
  } @else {
    <img
      (click)="openInvestments(banners()[0])"
      [src]="banners()[0].iconPath"
      width="100%"
      [id]="'BANNER_' + banners()[0].title"
      alt="banner"
    />
  }
</div>
